module.exports = __webpack_public_path__ + "img/star.c4f20091.gif";